import React from 'react';
import ToggleIcon from './Icons/ToggleIconV2';

const ToggleButton = ({ status, onToggle }) => {
  return (
    <button type="button" aria-pressed={status} onClick={onToggle} className="focus:outline-none">
      <ToggleIcon status={status} />
    </button>
  );
};

export default ToggleButton;
